import * as xAPI from './api/LRS'
import * as LMS from './LMS'

import { moduleID, debugUsername, debugUserID } from './App.config'
import { User } from './interfaces/Types'

export const getUser = async (): Promise<User> => {
    console.log('Initiliazing user...')
    const scormUsername: string = LMS.getStudentName()
    const scormUserID: string = LMS.getStudentID()
    const companyID: string = LMS.getCompanyID()
    const companyName: string = await xAPI.getCompanyName(companyID)
        .catch((err) => {
            throw new Error(`Error retrieving company name for company ID ${companyID}: ${err}`)
        })
    const isScormStudent = scormUserID === '' || scormUserID === undefined ? false : true

    const uname: string = isScormStudent
        ? scormUsername
        : debugUsername

    const uid: string = isScormStudent
        ? scormUserID
        : debugUserID

    const user: User = {
        userId: uid,
        userName: uname,
        companyId: companyID,
        companyName: companyName,
        moduleId: moduleID,
    }
    return user
}